import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';

import { LoaderOverlay } from '~/components/Loader';
import { LogoHeader } from '~/components/LogoHeader';
import { Page } from '~/components/Page';
import { Retry } from '~/components/Retry';
import { useJiraConfigQuery } from '~/hooks/useJiraConfigQuery';
import * as LAYOUT from '~/pages/layout';
import { RequestsPageUrl } from '~/pages/urls';

export const HomePage: React.FC = () => {
  const { palette } = useTheme();
  
  const { data: config, isLoading, isError, refetch } = useJiraConfigQuery();
  const markets = config?.fields?.reviewRegion?.allowedValues || [];

  return (
    <Page>
      <Box sx={[LAYOUT.HEADER]}>
        <LogoHeader />
      </Box>
      <Box sx={[LAYOUT.BODY, {
        display: 'flex',
        justifyContent: 'center',
        mt: '70px',
      }]}>
        <Box sx={{
          maxWidth: 1000,
          textAlign: 'center',
          width: '100%',
          flexDirection: 'column',
          justifyContent: 'center',
          display: 'flex',
        }}>
          {isError && <Retry retry={refetch} sx={{ margin: 'auto', transform: 'translateY(-50%)' }}>the markets</Retry>}
          {isLoading && <LoaderOverlay sx={{ position: 'relative', height: '90%' }} />}
          {!isLoading && !isError && (
            <Box sx={LAYOUT.BODY}>
              <Typography variant="h3" sx={{ color: palette.text.primary }}>
                Please select your market to proceed
              </Typography>
              <Typography variant="h3" sx={{ color: palette.text.primary, mb: 7 }}>
                {'You\'ll be able to change it later.'}
              </Typography>
              <Grid container sx={{ justifyContent: 'center' }} spacing="20px">
                {markets.map((market) => {
                  const { value } = market;
                  return (
                    <Grid item key={value} xs={4}>
                      <Button
                        to={RequestsPageUrl.expand({ market: value })}
                        component={RouterLink}
                        sx={{
                          justifyContent: 'flex-start',
                          borderRadius: '6px',
                          width: '100%',
                          fontSize: '22px',
                          lineHeight: '32px',
                          py: '14px',
                          px: '40px',
                          border: 0,
                        }}
                      >
                        {value}
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          )}
        </Box>
      </Box>
    </Page>
  );
}
